import React, { useEffect, useState, useContext, useRef } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/policylocker.css";
import policyLockerImg from "../assets/policylockerimg.webp";
import { FaFilePdf, FaChevronDown } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { UserContext } from '../UserContext';
import axios from "axios";
import { Helmet } from 'react-helmet-async';
import ChatbotAi from "../components/ChatbotAi";

const CustomSelect = ({ label, options, selectedValue, onSelect, error }) => {
  const [showOptions, setShowOptions] = useState(false);

  const handleOptionClick = (option) => {
    onSelect(option);
    setShowOptions(false);
  };

  return (
    <Form.Group className="mb-2">
      <Form.Label className="text-white">{label}:</Form.Label>
      <div className="policylocker-custom-select-wrapper">
        <div
          className={`policylocker-custom-select-header ${error ? "is-invalid-custom" : ""}`}
          onClick={() => setShowOptions(!showOptions)}
        >
          {selectedValue}
          <FaChevronDown className={`policylocker-dropdown-arrow ${showOptions ? "open" : ""}`} />
        </div>
        {showOptions && (
          <div className="policylocker-custom-select-options">
            {options.map((option, index) => (
              <div
                key={index}
                className="policylocker-custom-select-option"
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </div>
            ))}
          </div>
        )}
      </div>
      {error && (
        <div className="policylocker-validation-error">
          {error}
        </div>
      )}
    </Form.Group>
  );
};

const PolicyLocker = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const [WhosePolicy, setPolicyHolder] = useState("Self");
  const [PolicyType, setPolicyType] = useState("Health Insurance");
  const [PolicyNumber, setPolicyNumber] = useState("");
  const [NextRenewalDate, setNextRenewalDate] = useState("");
  const [PolicyDocument, setPolicyDocument] = useState(null);
  const [PolicyPdf, setPolicyPdf] = useState([]);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [Error, setError] = useState("");
  const [SuccessMessage, setSuccessMessage] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [errors, setErrors] = useState({});
  const fileInputRef = useRef(null);
  const API_URL = process.env.REACT_APP_MainSite_API_URL;
  const API_URL_Dash = process.env.REACT_APP_Dashboard_API_URL;
  const { UserId } = useContext(UserContext);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 200);

    setTimeout(() => {
      setFadeIn(true);
    }, 500);
  }, []);

  useEffect(() => {
    if (UserId) {
      Getdocumnets();
    }
  }, [UserId]);

  const handlePolicyHolderChange = (value) => {
    setPolicyHolder(value);
    setErrors(prevErrors => ({ ...prevErrors, WhosePolicy: "" }));
  };

  const handlePolicyTypeChange = (value) => {
    setPolicyType(value);
    setErrors(prevErrors => ({ ...prevErrors, PolicyType: "" }));
  };

  const handlePolicyNumberChange = (e) => {
    setPolicyNumber(e.target.value);
    if (errors.PolicyNumber) {
      setErrors(prevErrors => ({ ...prevErrors, PolicyNumber: "" }));
    }
  };

  const handleRenewalDateChange = (e) => {
    setNextRenewalDate(e.target.value);
    if (errors.NextRenewalDate) {
      setErrors(prevErrors => ({ ...prevErrors, NextRenewalDate: "" }));
    }
  };

  const handleDocumentChange = (e) => {
    setPolicyDocument(e.target.files[0]);
    if (errors.PolicyDocument) {
      setErrors(prevErrors => ({ ...prevErrors, PolicyDocument: "" }));
    }
  };

  const AddNewPolicy = async (e) => {
    e?.preventDefault();
    const newErrors = {};

    if (!WhosePolicy) newErrors.WhosePolicy = 'Please select policy holder.';
    if (!PolicyType) newErrors.PolicyType = 'Please select policy type.';
    if (!PolicyNumber) newErrors.PolicyNumber = 'Policy number is required.';
    if (!NextRenewalDate) newErrors.NextRenewalDate = 'Renewal date is required.';
    if (!PolicyDocument) newErrors.PolicyDocument = 'Please upload a document.';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    const formData = new FormData();
    formData.append("WhosePolicy", WhosePolicy);
    formData.append("PolicyType", PolicyType);
    formData.append("PolicyNumber", PolicyNumber);
    formData.append("NextRenewalDate", NextRenewalDate);
    formData.append("PolicyDocument", PolicyDocument);
    formData.append("UserId", UserId);
    try {
      const response = await axios.post(`${API_URL}AddNewPolicy`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        setSuccessMessage(response.data.message);
        setTimeout(() => {
          if (fileInputRef.current) {
            fileInputRef.current.value = null;
          }
          setPolicyNumber("");
          setNextRenewalDate("");
          setPolicyDocument(null);
          Getdocumnets();
          setSuccessMessage("");
        }, 2000);
      } else {
        setTimeout(() => {
          setErrorMessage(response.data.message);
        }, 2000);
      }
    } catch (error) {
      setTimeout(() => {
        setErrorMessage(error.response?.data?.message || "An error occurred while adding the policy.");
      }, 2000);
    }
  };

  const Getdocumnets = async () => {
    try {
      const response = await axios.get(`${API_URL}GetAllDocument/${UserId}`);
      if (response.status === 200) {
        const colorMap = {
          "Life Insurance": "#2CA2FB",
          "Vehicle Insurance": "#FF5733",
          "Car Insurance": "#FF5733",
          "Home Insurance": "#28A745",
          "Health Insurance": "#FFC107",
          "Two-Wheeler Insurance": "#9C27B0",
          "Cyber Insurance": "#FF9800",
          "Shopkeeper Insurance": "#607D8B",
          "Personal Accidental Insurance": "#E91E63",
          "Critical Insurance": "#795548",
          "Insurance with Investment": "#00BCD4"
        };

        const formattedData = response.data.map(doc => {
          const fileName = doc.policyDocument.split("\\").pop();
          return {
            id: doc.id,
            name: doc.policyType,
            link: `${API_URL_Dash}Document/${fileName}`,
            policyNumber: doc.policyNumber,
            color: colorMap[doc.policyType] || "#ccc",
          };
        });
        setPolicyPdf(formattedData);
        setError("");
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setPolicyPdf([]);
        setError("Document not available !");
      } else {
        setError("Document not available !");
      }
    }
  };

  const handleDelete = (id) => {
    setDeleteUserId(id);
    setShowConfirm(true);
  };

  const cancelDelete = () => {
    setShowConfirm(false);
    setDeleteUserId(null);
  };

  const DeleteDocumnets = async () => {
    if (deleteUserId) {
      try {
        const response = await axios.delete(`${API_URL}${deleteUserId}`);
        if (response.status === 200) {
          const updatedPdf = PolicyPdf.filter(doc => doc.id != deleteUserId);
          setPolicyPdf(updatedPdf);


          if (updatedPdf.length === 0) {
            setError("Document not available !");
          }

          setShowConfirm(false);
          setDeleteUserId(null);
          setErrorMessage('');
        } else {
          setShowConfirm(false);
          setDeleteUserId(null);
          setErrorMessage(response.data.message || "Failed to delete document.");
        }
      } catch (error) {
        setShowConfirm(false);
        setDeleteUserId(null);
        setErrorMessage(error.response?.data?.message || "An error occurred while deleting the document.");
      }
    }
  };

  const webApplicationSchema = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Policy Locker Service",
    "url": "https://policysamjho.com/policy-locker/",
    "applicationCategory": "FinancialApplication",
    "operatingSystem": "Any",
    "featureList": [
      "Secure policy storage",
      "Easy document upload",
      "Renewal date tracking",
      "Policy management"
    ],
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "INR"
    }
  };

  return (
    <Container className="policylocker-container">
      <Helmet>
        <title>Secure Your Policies Online | Policy Locker Service</title>
        <meta
          name="description"
          content="Store and manage your insurance policies securely in your personal Policy Locker. Easy access and expert support whenever you need it."
        />
        <meta
          name="keywords"
          content="policy upload, insurance policy review, how to understand your insurance policy, upload insurance policy for advice, insurance policy explanation, insurance policy help, clarity in insurance, personalized insurance advice India, secure policy storage"
        />
        <link rel="canonical" href="https://policysamjho.com/policy-locker/" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Policy Locker Service",
            "url": "https://policysamjho.com/policy-locker/",
            "applicationCategory": "FinancialApplication",
            "operatingSystem": "Any",
            "featureList": [
              "Secure policy storage",
              "Easy document upload",
              "Renewal date tracking",
              "Policy management"
            ],
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "INR"
            }
          })}
        </script>
      </Helmet>
      <Row className="align-items-center g-0">
        <Col md={6} className={`text-center ${isVisible ? "slide-in-left" : "hidden"}`}>
          <h1 className="policylocker-main-h1" style={{ marginBottom: "20px", fontSize: "1rem", fontWeight: 'bold' }}>
            Secure Policy Locker & Insurance Management
          </h1>
          <img src={policyLockerImg} alt="Policy Locker" className="policylocker-image reduced-size" />
        </Col>

        <Col md={6} className={`policylocker-form-container p-4 ${isVisible ? "slide-in-right" : "hidden"}`}>
          <h2 className="mb-3 text-white policylocker-heading">Enter Your Policy Details</h2>
          <Form onSubmit={AddNewPolicy} noValidate>
            <Form.Group className="mb-2">
              <CustomSelect
                label="Whose Policy"
                options={["Self", "Spouse", "Child", "Parents"]}
                selectedValue={WhosePolicy}
                onSelect={handlePolicyHolderChange}
                error={errors.WhosePolicy}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <CustomSelect
                label="Policy Type"
                options={["Health Insurance", "Life Insurance", "Car Insurance", "Home Insurance", "Two-Wheeler Insurance", "Cyber Insurance", "Shopkeeper Insurance", "Personal Accidental Insurance", "Critical Insurance", "Insurance with Investment"]}
                selectedValue={PolicyType}
                onSelect={handlePolicyTypeChange}
                error={errors.PolicyType}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="text-white">Policy Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter policy number"
                value={PolicyNumber}
                onChange={handlePolicyNumberChange}
                className={errors.PolicyNumber ? "is-invalid-custom" : ""}
              />
              {errors.PolicyNumber && (
                <div className="policylocker-validation-error">
                  {errors.PolicyNumber}
                </div>
              )}
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="text-white">Next Renewal Date</Form.Label>
              <Form.Control
                type="date"
                value={NextRenewalDate}
                onChange={handleRenewalDateChange}
                className={errors.NextRenewalDate ? "is-invalid-custom" : ""}
              />
              {errors.NextRenewalDate && (
                <div className="policylocker-validation-error">
                  {errors.NextRenewalDate}
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label className="text-white">Upload Policy Document</Form.Label>
              <Form.Control
                type="file"
                ref={fileInputRef}
                onChange={handleDocumentChange}
                className={errors.PolicyDocument ? "is-invalid-custom" : ""}
              />
              {errors.PolicyDocument && (
                <div className="policylocker-validation-error">
                  {errors.PolicyDocument}
                </div>
              )}
            </Form.Group>

            <Button type="submit" className="policylocker-button mt-4">
              + Add New Policy
            </Button>
          </Form>
          {SuccessMessage && (
            <div className="policylocker-success-message">
              {SuccessMessage}
            </div>
          )}
          {ErrorMessage && (
            <div className="policylocker-error-message">
              {ErrorMessage}
            </div>
          )}
        </Col>
      </Row>

      <div className="policylocker-suggection-div">
        <Row className="policylocker-suggested-section">
          <Col>
            <h2 className="policylocker-suggested-heading">
              <span className="policylocker-white-text">Hassle-Free Insurance</span>
              <span className="policylocker-blue-text"> Document Storage</span>
            </h2>

            <div className="policylocker-suggested-policies">
              {PolicyPdf.map((policy, index) => (
                <div key={index} className={`policylocker-suggested-policy-item fade-in ${fadeIn ? "show" : ""}`} style={{ borderColor: policy.color }}>
                  <MdDelete
                    onClick={() => { handleDelete(policy.id); }}
                    className="policylocker-delete-icon"
                  />
                  <h4 className="policylocker-title" style={{ color: policy.color }}>{policy.name}</h4>
                  <h5 className="policylocker-number">{policy.policyNumber}</h5>
                  <div className="policylocker-download-text">
                    <a
                      href={policy.link}
                      download
                      className="policylocker-download-btn"
                    >
                      <FaFilePdf className="policylocker-pdf-icon" style={{ color: policy.color }} />
                      <span className="policylocker-download-label">View PDF</span>
                    </a>
                  </div>
                </div>
              ))}
            </div>
            {showConfirm && (
              <div className="policylocker-confirm-modal">
                <div className="policylocker-confirm-content">
                  <h2 className="policylocker-confirm-title">Confirm for Delete Document</h2>
                  <p className="policylocker-confirm-text">Are you sure you want to delete this Document?</p>
                  <div className="policylocker-confirm-buttons">
                    <button
                      className="policylocker-delete-button"
                      onClick={DeleteDocumnets}
                    >
                      Delete
                    </button>
                    <button
                      className="policylocker-cancel-button"
                      onClick={cancelDelete}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}
            {Error && (
              <div className="policylocker-error-message text-center mt-3">
                {Error}
              </div>
            )}
          </Col>
        </Row>
      </div>
      <ChatbotAi />
    </Container>
  );
};

export default PolicyLocker;